import { RGBColor } from '@ui-kit/types/color'

type TintAlgorithm = (baseColor: RGBColor) => RGBColor[]

const colorBlack = { r: 0, g: 0, b: 0, a: 1 }
const colorWhite = { r: 255, g: 255, b: 255, a: 1 }

const mixColors = (
  baseColor: RGBColor,
  mixColor: RGBColor,
  percentage: number
): RGBColor => {
  const baseRgb = baseColor
  const mixRgb = mixColor
  const ratio = percentage / 100

  const mixedRgb = {
    r: Math.round(baseRgb.r * (1 - ratio) + mixRgb.r * ratio),
    g: Math.round(baseRgb.g * (1 - ratio) + mixRgb.g * ratio),
    b: Math.round(baseRgb.b * (1 - ratio) + mixRgb.b * ratio),
    a: 1
  }

  return mixedRgb
}

const algorithm1: TintAlgorithm = baseColor => [
  mixColors(baseColor, colorWhite, 85),
  mixColors(baseColor, colorWhite, 50),
  baseColor,
  mixColors(baseColor, colorBlack, 50),
  mixColors(baseColor, colorBlack, 85)
]

const algorithm2: TintAlgorithm = baseColor => [
  mixColors(baseColor, colorWhite, 100),
  mixColors(baseColor, colorWhite, 70),
  baseColor,
  mixColors(baseColor, colorBlack, 50),
  mixColors(baseColor, colorBlack, 90)
]

const algorithms = {
  algorithm1,
  algorithm2
}

export type ColorTintsAlgorithmType = keyof typeof algorithms

export const createColorTints = ({
  baseColor,
  algorithm
}: {
  baseColor: RGBColor
  algorithm: ColorTintsAlgorithmType
}) => {
  const selectedAlgorithm = algorithms[algorithm]

  if (!selectedAlgorithm) {
    throw new Error(`Algorithm "${algorithm}" is not supported.`)
  }
  return selectedAlgorithm(baseColor)
}
